module.exports = __webpack_public_path__ + "assets/images/1348f05457f5e40e5373665b35f573ea.png";